interface Props {
  warnings: readonly string[] | undefined;
}

/**
 * What the import left out or could not check, without failing it: e.g. a fiscal schedule without a usable calendar,
 * or a grant of a privilege this system no longer has (nap-backend#2010). Shown below the errors; nothing when empty.
 */
export const ImportWarnings = ({ warnings }: Props) => {
  if (!warnings || warnings.length === 0) return null;
  return (
    <div className="alert alert-warning py-2 small mb-3">
      <strong>Warnings:</strong>
      <ul className="mb-0 ps-3">
        {warnings.map((warning, i) => (
          <li key={i}>{warning}</li>
        ))}
      </ul>
    </div>
  );
};
